import { render, staticRenderFns } from "./EditarGrilla.vue?vue&type=template&id=501adb48&"
import script from "./EditarGrilla.vue?vue&type=script&lang=ts&"
export * from "./EditarGrilla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('501adb48', component.options)
    } else {
      api.reload('501adb48', component.options)
    }
    module.hot.accept("./EditarGrilla.vue?vue&type=template&id=501adb48&", function () {
      api.rerender('501adb48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MotivodeBaja/EditarGrilla.vue"
export default component.exports